/**
 * Anti-Inspect Protection
 *
 * Prevents casual users and competitors from easily inspecting
 * the landing page source code via browser DevTools.
 *
 * NOTE: This deters ~90% of casual users. Experienced developers
 * can always bypass client-side protections.
 */

export const initAntiInspect = (): (() => void) => {
  if (typeof window === 'undefined') return () => {}

  // 1. Block right-click context menu
  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault()
    return false
  }

  // 2. Block keyboard shortcuts for DevTools
  const handleKeyDown = (e: KeyboardEvent) => {
    // F12
    if (e.key === 'F12') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+I (Inspect Element)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+C (Element picker)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault()
      return false
    }
    // Ctrl+U (View Source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
    // Ctrl+S (Save page)
    if (e.ctrlKey && e.key === 's') {
      e.preventDefault()
      return false
    }
    // Cmd variants for Mac
    if (e.metaKey && e.altKey && e.key === 'i') {
      e.preventDefault()
      return false
    }
    if (e.metaKey && e.altKey && e.key === 'j') {
      e.preventDefault()
      return false
    }
    if (e.metaKey && e.altKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
  }

  // 3. Block drag on images
  const handleDragStart = (e: DragEvent) => {
    if (e.target instanceof HTMLImageElement) {
      e.preventDefault()
      return false
    }
  }

  // 4. Detect DevTools via debugger timing
  let devtoolsCheckInterval: ReturnType<typeof setInterval> | null = null

  const startDevToolsDetection = () => {
    devtoolsCheckInterval = setInterval(() => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160
      const heightThreshold = window.outerHeight - window.innerHeight > 160

      if (widthThreshold || heightThreshold) {
        // DevTools likely open — you could redirect or show a message
        // For now, just log it (uncomment redirect if desired)
        // window.location.href = 'about:blank'
        console.log('%c⚠️ DevTools detectado', 'color: red; font-size: 20px;')
        console.log(
          '%cEsta página está protegida. El código fuente no está disponible para inspección.',
          'color: gray; font-size: 14px;',
        )
      }
    }, 1000)
  }

  // 5. Console warning message
  const showConsoleWarning = () => {
    console.log(
      '%c⛔ ALTO',
      'color: red; font-size: 60px; font-weight: bold; text-shadow: 2px 2px black;',
    )
    console.log(
      '%cEsta función del navegador está destinada a desarrolladores. Si alguien te dijo que copiaras algo aquí, es una estafa.',
      'color: gray; font-size: 16px;',
    )
  }

  // Attach all listeners
  document.addEventListener('contextmenu', handleContextMenu)
  document.addEventListener('keydown', handleKeyDown)
  document.addEventListener('dragstart', handleDragStart)
  startDevToolsDetection()
  showConsoleWarning()

  // Return cleanup function
  return () => {
    document.removeEventListener('contextmenu', handleContextMenu)
    document.removeEventListener('keydown', handleKeyDown)
    document.removeEventListener('dragstart', handleDragStart)
    if (devtoolsCheckInterval) {
      clearInterval(devtoolsCheckInterval)
    }
  }
}
